/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { DictionaryEntryDto } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class ContractTypeController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags contract-type-controller
   * @name ApiV1ContracttypeViewsDictionaryUsingGet
   * @summary viewDictionary
   * @request GET:/api/v1/contractType/views/dictionary
   * @secure
   */
  apiV1ContracttypeViewsDictionaryUsingGet = (params: RequestParams = {}) =>
    this.request<DictionaryEntryDto[], void>({
      path: `/api/v1/contractType/views/dictionary`,
      method: "GET",
      secure: true,
      ...params,
    });
}
